import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Gift = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M19.9707 10.4077H3.9707V18.4077C3.9707 21.4077 4.9707 22.4077 7.9707 22.4077H15.9707C18.9707 22.4077 19.9707 21.4077 19.9707 18.4077V10.4077Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5 7.40771V8.40771C21.5 9.50771 20.97 10.4077 19.5 10.4077H4.5C2.97 10.4077 2.5 9.50771 2.5 8.40771V7.40771C2.5 6.30771 2.97 5.40771 4.5 5.40771H19.5C20.97 5.40771 21.5 6.30771 21.5 7.40771Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4"
            d="M11.6408 5.40766H6.12076C5.78076 5.03766 5.79076 4.46766 6.15076 4.10766L7.57076 2.68766C7.94076 2.31766 8.55076 2.31766 8.92076 2.68766L11.6408 5.40766Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4"
            d="M17.8696 5.40766H12.3496L15.0696 2.68766C15.4396 2.31766 16.0496 2.31766 16.4196 2.68766L17.8396 4.10766C18.1996 4.46766 18.2096 5.03766 17.8696 5.40766Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4"
            d="M8.93945 10.4077V15.5477C8.93945 16.3477 9.81945 16.8177 10.4895 16.3877L11.4295 15.7677C11.7695 15.5477 12.1995 15.5477 12.5295 15.7677L13.4195 16.3677C14.0795 16.8077 14.9695 16.3377 14.9695 15.5377V10.4077H8.93945Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

Gift.displayName = 'Gift';
